<template>
	<div class="">
		<div class="case-pice"><span class="case-pice-first">报名记录</span> <span class="case-pice-and">/</span> <span class="case-pice-second">查看报名记录</span></div>
		<div class="common-title">
			基本信息
			<el-button style='float: right;' size='small' type="info" @click='goBack()' plain>返回</el-button>
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">学员姓名：</div>
					<el-input disabled v-model="signUpData.name" clearable class='grid-input' size='small'
						placeholder=""></el-input>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">性别：</div>
					<el-select disabled size='small' class='grid-input' v-model="signUpData.sex" clearable
						placeholder="">
						<el-option v-for="item in sexList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">手机号码：</div>
					<el-input disabled v-model="signUpData.phone" clearable class='grid-input' size='small'
						placeholder=""></el-input>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">培训类别：</div>
					<el-select  size='small' class='grid-input' disabled 
						v-model="signUpData.trainingClasses" clearable placeholder="">
						<el-option v-for="item in tarinTypeList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">专业类别：</div>
					<el-select disabled size='small' class='grid-input' clearable v-model="signUpData.professionalClasses"
						clearable placeholder="">
						<el-option v-for="(item,index) in majorCategoryList" :key="index" :label="item.codeCname"
							:value="item.codeCode">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">培训人员：</div>
					<el-select size='small' disabled class='grid-input' v-model="signUpData.trainers" clearable
						placeholder="">
						<el-option v-for="item in trainersList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">证件类型：</div>
					<el-select disabled size='small' class='grid-input' v-model="signUpData.idType" clearable
						placeholder="">
						<el-option v-for="(item,index) in cardTypeList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">证件号码：</div>
					<el-input disabled v-model="signUpData.idCard" clearable class='grid-input' size='small'
						placeholder=""></el-input>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">学历：</div>
					<el-select size='small' class='grid-input' disabled v-model="signUpData.education" clearable
						placeholder="">
						<el-option v-for="(item,index) in educationList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">健康状况：</div>
					<el-select size='small' class='grid-input' disabled v-model="signUpData.healthState" clearable
						placeholder="">
						<el-option v-for="item in healthList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">出生日期：</div>
					<div style="flex: 1;">
						<el-date-picker size='small' style="width: 100%;" disabled v-model="signUpData.birthday" type="date"
							placeholder=""></el-date-picker>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">民族：</div>
					<div style="flex: 1;">
						<el-select size='small' class='common-full-width' disabled v-model="signUpData.nation" clearable
							placeholder="">
							<el-option v-for="item in nationList" :key="item.cc" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">专业技术职务：</div>
					<div style="flex: 1;">
						<el-select size='small' class='common-full-width' disabled v-model="signUpData.technicalPosition"
							clearable placeholder="">
							<el-option v-for="item in technicalList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">电子邮箱：</div>
					<el-input v-model="signUpData.email" clearable disabled class='grid-input' size='small'
						placeholder=""></el-input>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">受聘时间：</div>
					<div style="flex: 1;">
						<el-date-picker size='small' style="width: 100%;" disabled v-model="signUpData.employedDate"
							type="date" placeholder=""></el-date-picker>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">毕业院校：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.graduateSchool" disabled clearable class='common-full-width'
							size='small' placeholder=""></el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">毕业时间：</div>
					<div style="flex: 1;">
						<el-date-picker size='small' style="width: 100%;" disabled v-model="signUpData.graduationDate"
							type="date" placeholder=""></el-date-picker>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">通讯地址：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.homeAddress" clearable disabled class='common-full-width' size='small'
							placeholder=""></el-input>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">专业：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.major" clearable disabled class='common-full-width' size='small'
							placeholder=""></el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">学位：</div>
					<div style="flex: 1;">
						<el-select size='small' class='common-full-width' disabled v-model="signUpData.degree" clearable
							placeholder="">
							<el-option v-for="item in degreeList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">考试科目：</div>
					<div style="flex: 1;">
						<el-select size='small' class='common-full-width' disabled v-model="signUpData.examSubject" clearable
							placeholder="">
							<el-option v-for="item in examSubjectList" :key="item.code" :label="item.name"
								:value="item.code">
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">证书邮寄地址：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.mailingAddress" disabled clearable class='common-full-width'
							size='small' placeholder=""></el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">收件人：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.recipients" disabled clearable class='common-full-width' size='small'
							placeholder=""></el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label">联系电话：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.recipientsPhone" disabled clearable class='common-full-width'
							size='small' placeholder=""></el-input>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content">
					<div class="grid-label" style="width: 200px;">累计从事道路运输工作年限：</div>
					<div style="flex: 1;">
						<el-input v-model="signUpData.yearsOfWorking" disabled clearable class='common-full-width'
							size='small' placeholder=""></el-input>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
		
			</el-col>
			<el-col :span="8">
		
			</el-col>
		</el-row>
		<!-- <div class="common-title">
			工作经历
		</div> -->
		<!-- <div v-if="signUpData.workHistory.length == 0" style="color: #ccc;">
			暂无工作经历
		</div>
		<div v-for="(item,index) in signUpData.workHistory" :key='index' v-else>
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="grid-content company-title">{{item.company}} <span style="margin-left: 30px;" class="company-text">{{item.workStartTime}}至 {{item.workEndTime}}</span></div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="8">
					<div class="grid-content company-text">部门：{{item.department}}</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content company-text">职位：{{item.position}}</div>
				</el-col>
			</el-row>
			<div>
				<div class="grid-content company-text">
					职责描述
				</div>
				<div style='line-height: 30px;'>
					{{item.workContent}}
				</div>
			</div>
		</div> -->
		<div class="common-title">
			培训项目
		</div>
		<el-row :gutter="20">
			<el-col :span="24">
				<div class="grid-content company-title">{{signUpData.companyName}} <span style="margin-left: 30px;" class="company-text">{{signUpData.applicationDate}} -  <span v-if="signUpData.completeDate==null ||signUpData.completeDate==''">至今</span><span v-else>{{signUpData.completeDate}}</span></span>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="6">
				<div class="grid-content company-text">审核状态：
					<span v-if="signUpData.applicationStatus == 0">已取消</span>
					<span v-if="signUpData.applicationStatus == 1">未审核</span>
					<span v-if="signUpData.applicationStatus == 2">审核通过</span>
					<span v-if="signUpData.applicationStatus == 3">审核驳回</span>
				</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content company-text">培训类别：
					<span v-if='signUpData.trainingClasses == 1'>初次培训</span>
					<span v-if='signUpData.trainingClasses == 2'>继续教育</span></div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content company-text">专业类别：{{signUpData.professionalClassesName}}</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-content company-text">培训人员：
					<span v-if='signUpData.trainers == 1'>负责人</span>
					<span v-if='signUpData.trainers == 2'>安全管理人员</span>
					<span v-if='signUpData.trainers == 3'>动态监控</span>
					<span v-if='signUpData.trainers == 4'>其他</span>
				</div>
			</el-col>
		</el-row>
		<div class="common-title">
			会员单位信息
		</div>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="grid-content company-title">{{signUpData.companyName}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">统一社会代码：{{signUpData.creditCode}}</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-content company-text">所属区县：{{signUpData.companyAddress}}</div>
			</el-col>
			<el-col :span="14">
				<div class="grid-content company-text">营业执照地址：{{signUpData.businessAddress}}</div>
			</el-col>
		</el-row>
		<el-row :gutter="40" id='imgTooles'>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.businessLicenseImg' :src="signUpData.businessLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					营业执照
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.vipFormImg' :src="signUpData.vipFormImg" alt="" />
				</div>
				<div class="grid-text">
					会员单位申请表
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.transportLicenseImg' :src="signUpData.transportLicenseImg" alt="" />
				</div>
				<div class="grid-text">
					道路运输许可证
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.appointmentImg' :src="signUpData.appointmentImg" alt="" />
				</div>
				<div class="grid-text">
					总经理任命书
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.personImg' :src="signUpData.personImg" alt="" />
				</div>
				<div class="grid-text">
					学员证件照片
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.idCardFrontImg' :src="signUpData.idCardFrontImg" alt="" />
				</div>
				<div class="grid-text">
					证件照片正面
				</div>
			</el-col>
			<el-col :span="8">
				<div class="grid-img" @click="preImage()">
					<img :data-original='signUpData.idCardBackImg' :src="signUpData.idCardBackImg" alt="" />
				</div>
				<div class="grid-text">
					证件照片背面
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="40">
		</el-row>
		<div class="common-title">
			安全证书
		</div>
		<el-col :span="8" v-if="signUpData.safetyCertificateImg != ''">
			<div @click="preImage11()" class="grid-img"  id='imgToolesSafe'  :data-original='signUpData.safetyCertificateImg'> 
				<img :src="signUpData.safetyCertificateImg" alt="" />
			</div>
			<div class="grid-text">
				安全证书
			</div>
		</el-col>
		<div v-else style="color: #ccc;">
			暂无安全证书
		</div>
	</div>
</template>

<script>
	import Viewer from 'viewerjs';
	import { getSignUpDetail,majorTypeList } from '../../api/main'
	export default {
		data() {
			return {
				signUpData: {},
				healthList: [{
					value: "1",
					name: '严重'
				}, {
					value: "2",
					name: '一切正常'
				}, {
					value: "3",
					name: '状况欠佳'
				}],
				sexList: [{
					label: '男',
					value: '0'
				}, {
					label: '女',
					value: '1'
				}],
				tarinTypeList: [{
					label: '初次培训',
					value: '1'
				}, {
					label: '继续教育',
					value: '2'
				}],
				majorCategoryList: [],
				trainersList: [{
					label: '负责人',
					value: '1'
				}, {
					label: '安全管理人员',
					value: "2"
				}, {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}],
			}
		},
		mounted() {
			this.getDetail();
			this.getMajorDataList();
		},
		computed: {
			cardTypeList() {
				let cardTypeList = JSON.parse(sessionStorage.getItem('cardTypeList'));
				cardTypeList.shift();
				return cardTypeList;
			},
			nationList() {
				let nationList = JSON.parse(sessionStorage.getItem('nationList'));
				nationList.shift();
				return nationList;
			},
			technicalList() {
				let technicalList = JSON.parse(sessionStorage.getItem('technicalList'));
				technicalList.shift();
				return technicalList;
			},
			degreeList() {
				let degreeList = JSON.parse(sessionStorage.getItem('degreeList'));
				degreeList.shift();
				return degreeList;
			},
			examSubjectList() {
				let examSubjectList = JSON.parse(sessionStorage.getItem('examSubjectList'));
				examSubjectList.shift();
				return examSubjectList;
			},
			educationList() {
				let educationList = JSON.parse(sessionStorage.getItem('educationList'));
				return educationList;
			},
		},
		methods: {
			getMajorDataList() {
				majorTypeList({
					current: 1,
					pageSize: 30,
					professionalName: ''
				}).then(res => {
					this.majorCategoryList = res.data.records;
				})
			},
			preImage() {
				const ViewerDom = document.getElementById('imgTooles');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			preImage11(){
				const ViewerDom = document.getElementById('imgToolesSafe');
				const viewer = new Viewer(ViewerDom, {
					url: "data-original"
				});
			},
			getDetail() {
				getSignUpDetail(this.$store.state.signUpRecordId).then(res => {
					console.log(res)
					this.signUpData = res.data;
				})
			},
			goBack() {
				this.$router.go(-1);
			}
		}
	}
</script>

<style lang="less">
	.company-change-detail {
		font-size: 16px;
	}
	
	.company-text span {
		font-size: 16px;
	}
</style>